/* eslint no-unused-vars: 0 */

import React from 'react';
import SiteSearchCategoryResults from './category_results';
import SiteSearchBrandResults from './brand_results';
import SiteSearchProductResults from './product_results';

class SiteSearch extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      loading: false,
      queried: false,
      products: [],
      prices: [],
      pricing_error: false,
      categories: [],
      brands: [],
      error: false,
      mobile: false,
    };

    this.closeSearch = this.closeSearch.bind(this);
    this.triggerSearch = this.triggerSearch.bind(this);
    this.debounceInput = this.debounceInput.bind(this);
    this.fullSearch = this.fullSearch.bind(this);
    this.search = this.search.bind(this);
    this.getPrices = this.getPrices.bind(this);
    this.viewLink = this.viewLink.bind(this);
    this.validateMobileDevice = this.validateMobileDevice.bind(this);

    this.handleSearch = this.debounceInput(e => {
      if (e.target.value === '') {
        this.closeSearch();
      } else {
        if (e.keyCode === 27) {
          this.closeSearch();
        } else if (e.keyCode === 13) {
          if (e.target.value.length > 0) {
            this.fullSearch(true, e.target.value.trim());
          }
        } else {
          this.setState({ query: e.target.value.trim() }, () => {
            this.search();
          });
        }
      }
    }, 500);
  }

  componentDidMount() {
    this.setState({ mobile: this.props.mobile }, () => {
      this.validateMobileDevice();
    });
  }

  validateMobileDevice() {
    let excludedDevices = [[600, 960]];
    let deviceDimensions = [window.screen.width, window.screen.height];
    if (
      JSON.stringify(excludedDevices).indexOf(
        JSON.stringify(deviceDimensions),
      ) != -1
    ) {
      this.setState({ mobile: true });
    }
  }

  fullSearch(force = false, input = '') {
    if (force === true && input !== '') {
      window.location.href = `/catalogue/products/search?q=${encodeURIComponent(
        input,
      )}`;
    } else if (this.state.query !== '') {
      window.location.href = `/catalogue/products/search?q=${encodeURIComponent(
        this.state.query,
      )}`;
    }
  }

  viewLink(address) {
    window.location.href = address;
  }

  triggerSearch(e) {
    this.setState(
      {
        query: e.target.value.trim(),
      },
      () => {
        if (this.state.query !== '') {
          this.search();
        }
      },
    );
  }

  closeSearch() {
    document.querySelector('.main-search').value = '';
    this.setState({
      products: [],
      queried: false,
      categories: [],
      brands: [],
      error: false,
      query: '',
    });
  }

  debounceInput(a, b, c) {
    var d, e;
    return function () {
      function h() {
        (d = null), c || (e = a.apply(f, g));
      }
      var f = this,
        g = arguments;
      return (
        clearTimeout(d),
        (d = setTimeout(h, b)),
        c && !d && (e = a.apply(f, g)),
        e
      );
    };
  }

  search() {
    this.setState({ loading: true, prices: [], pricing_error: false });
    if (this.state.mobile !== true) {
      $.ajax({
        url: '/catalogue/products/autocomplete',
        data: { query: this.state.query },
        dataType: 'JSON',
        success: data => {
          let categories = data.categories.filter(cat => {
            return cat.highlighted_name !== undefined;
          });

          this.setState({
            products: data.products,
            categories,
            brands: data.brands,
            loading: false,
            error: false,
            queried: true,
          });

          this.getPrices();
        },
        error: () => {
          this.setState({ error: true });
        },
      });
    }
  }

  getPrices() {
    this.setState({ loadingPrices: true });
    if (this.props.signed_in === true) {
      const products = this.state.products.map(p => p.id).join(',');
      $.ajax({
        url: '/product_price',
        data: { products },
        dataType: 'JSON',
        success: prices => {
          this.setState({ prices: prices, loadingPrices: false });
        },
        error: () => {
          this.setState({ pricing_error: true, loadingPrices: false });
        },
      });
    } else {
      this.setState({ pricing_error: true, prices: [], loadingPrices: false });
    }
  }

  render() {
    const {
      customer_services_email: customerServicesEmail,
      b2b_phone_number: b2bPhoneNumber,
      vat_exclusive: vatExclusive,
      assets,
    } = this.props;

    let results =
      this.state.query !== '' &&
      this.state.queried === true &&
      this.state.mobile !== true ? (
        <div className="search-results">
          <div className="container results-container">
            <div className="fl">
              <div className="span3 brand-category-results">
                <SiteSearchCategoryResults
                  categories={this.state.categories}
                  viewLink={this.viewLink}
                  query={this.state.query}
                  brandCount={this.state.brands.length}
                />
                <SiteSearchBrandResults
                  brands={this.state.brands}
                  viewLink={this.viewLink}
                  query={this.state.query}
                  categoryCount={this.state.categories.length}
                />
              </div>
              <SiteSearchProductResults
                customerServicesEmail={customerServicesEmail}
                products={this.state.products}
                prices={this.state.prices}
                pricing_error={this.state.pricing_error}
                query={this.state.query}
                viewLink={this.viewLink}
                fullSearch={this.fullSearch}
                b2bPhoneNumber={b2bPhoneNumber}
                assets={assets}
                query={this.state.query}
                vat_exclusive={vatExclusive}
                loadingPrices={this.state.loadingPrices}
              />
            </div>
          </div>
        </div>
      ) : (
        ''
      );
    return (
      <div
        className={
          'main-site-search' + (this.state.queried === true ? ' active' : '')
        }
        onClick={e =>
          e.target.className === 'main-site-search active'
            ? this.closeSearch()
            : null
        }>
        <div
          className={
            'search-input-wrapper' +
            (this.state.queried === true ? ' container active' : '')
          }>
          <button
            className="close-search"
            onClick={() => {
              this.closeSearch();
            }}>
            Close <img src={assets.close} alt="" height={18} width={18} />
          </button>
          <div className="inputs">
            <input
              type="text"
              onFocus={e => {
                e.persist();
                this.triggerSearch(e);
              }}
              onKeyDown={e => {
                e.persist();
                this.handleSearch(e);
              }}
              onChange={e => {
                e.persist();
                this.handleSearch(e);
              }}
              onPaste={e => {
                e.persist();
                this.handleSearch(e);
              }}
              onClick={e => e.stopPropagation()}
              spellCheck="false"
              className="main-search"
              aria-label="search"
              placeholder="Search by keyword or part number"
            />
            <button
              aria-label="search"
              onClick={e => {
                this.fullSearch();
                e.stopPropagation();
              }}>
              <img alt="" src={assets.search_white} height={17} width={18} />
            </button>
          </div>
          {results}
        </div>
      </div>
    );
  }
}

export default SiteSearch;
